import type { Router } from 'vue-router';
import { AUTH_LOGOUT } from '@/store/actions';
import { useAuthStore } from '@/stores/auth';
import { pinia } from '@/stores/pinia';
import { KillWebsocket } from '@/websockets/notifications';

// Login shows the session-expired banner, and signing back in returns the user
// to the page they were on.
export const endExpiredSession = async (router: Router): Promise<void> => {
	const authStore = useAuthStore(pinia);
	const from = router.currentRoute.value;

	await authStore[AUTH_LOGOUT]();
	KillWebsocket();
	authStore.showExpiryMessage = true;
	authStore.setRouterTo(from);
	await router.push({ name: 'Login' });
};
